import { render, staticRenderFns } from "./tipsPopup.vue?vue&type=template&id=9d29aa3c&scoped=true&"
import script from "./tipsPopup.vue?vue&type=script&lang=js&"
export * from "./tipsPopup.vue?vue&type=script&lang=js&"
import style0 from "./tipsPopup.vue?vue&type=style&index=0&id=9d29aa3c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d29aa3c",
  null
  
)

export default component.exports